var map = {
	"./img/allowcors.png": "8a78",
	"./img/avatar/blank-dpd.jpg": "ff7e",
	"./img/avatar/blank-eks.jpg": "6b18",
	"./img/avatar/man_4.jpg": "01bb",
	"./img/bg/1.jpg": "7d36",
	"./img/bg/11.jpg": "e092",
	"./img/bg/12.jpg": "e343",
	"./img/bg/13.jpg": "e63e",
	"./img/bg/14.jpg": "a59e",
	"./img/bg/16.jpg": "1e4f",
	"./img/bg/forest.jpg": "f2c4",
	"./img/bg/frcground.jpg": "9c30",
	"./img/m.png": "9dfc",
	"./img/m.svg": "6b93",
	"./img/nature/n1.jpeg": "d271",
	"./img/nature/n2.jpeg": "25f8",
	"./img/nature/n3.jpeg": "faba",
	"./img/nature/n4.jpeg": "3b3d",
	"./img/nature/n5.jpeg": "17fe",
	"./img/nature/n6.jpeg": "f7f8",
	"./img/nature/n7.jpeg": "8928",
	"./img/nature/n8.jpg": "55e2",
	"./img/nocors.png": "5896",
	"./img/nocors2.png": "9c4f",
	"./logo.png": "cf05",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";